import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "dateDropdown", "dateInput", "dateList", "dateDropdownBtn", "datesBtnGroup", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--clients--show--dates`
    this.loader = this.getControllerByIdentifier("app--helpers--loaders").loader()
    this.doDatesPreloader()
  }

  changeDate(ev) {
    var id = ev.currentTarget.dataset.id
    this.setClinicDate(id)
    this.toggleDateBtn(id)
  }

  setClinicDate(id) {
    var findElement = false
    this.application.dates.forEach(element => {
      if (element.id == id) {
        findElement = true
        this.application.current_date = element
        if (this.application.current_date.open == false) {
          this.application.current_date.message = `A Competência está fechada`
        }
      }
    });

    if (findElement == false) {
      this.application.current_date = { open: false, not_defined: true, message: `A Competência está fechada` }
    }

    this.getControllerByIdentifier("operations--products--clinics--clients--show--main").reload = true
    this.getControllerByIdentifier("operations--products--clinics--clients--show--main").loadDateData()
    this.getControllerByIdentifier("operations--products--clinics--clients--show--main").doSubtitle()
    this.getControllerByIdentifier("operations--products--clinics--clients--show--submenu").doBadgeCounts()
  }

  setCurrents() {
    this.application.regimes.forEach(element => {
      if (element.date_id == this.application.current_date.id) {
        this.application.current_regime = element
      }
    })

    this.application.main_apurations.forEach(element => {
      if (element.date_id == this.application.current_date.id) {
        this.application.current_main_apuration = element
      }
    })
  }

  runDashboardsHtml() {
    this.cleanClinicForms()
    this.runDashboardHtml()
    this.runApurationsHtml()
    this.runReceivablesHtml()
    this.runTaxesHtml()
    this.runExpensesHtml()
    this.runTransfersHtml()
  }

  cleanClinicForms() {
    if (this.getControllerByIdentifier("operations--products--clinics--clients--add--save")) {
      this.getControllerByIdentifier("operations--products--clinics--clients--add--save").goToReceivables()
    }
  }

  runDashboardHtml() {
    if (this.getControllerByIdentifier("operations--products--clinics--clients--show--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--clinics--clients--show--dashboard").doClinicDashboard()
    }
  }

  runReceivablesHtml() {
    if (this.getControllerByIdentifier("operations--products--clinics--clients--receivables--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--clinics--clients--receivables--dashboard").doReceivablesDashboard()
    }
  }

  runApurationsHtml() {
    if (this.getControllerByIdentifier("operations--products--clinics--clients--apurations--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--clinics--clients--apurations--dashboard").doApurationsDashboard()
    }
  }

  runTaxesHtml() {
    if (this.getControllerByIdentifier("operations--products--clinics--clients--taxes--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--clinics--clients--taxes--dashboard").doTaxesDashboard()
    }
  }

  runBalancesHtml() {
    if (this.getControllerByIdentifier("operations--products--clinics--clients--balances--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--clinics--clients--balances--dashboard").doBalancesDashboard()
    }
  }

  runTransfersHtml() {
    if (this.getControllerByIdentifier("operations--products--clinics--clients--transfers--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--clinics--clients--transfers--dashboard").doTransfersDashboard()
    }
  }

  runExpensesHtml() {
    if (this.getControllerByIdentifier("operations--products--clinics--clients--expenses--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--clinics--clients--expenses--dashboard").doExpensesDashboard()
    }
  }

  runTransfersHtml() {
    if (this.getControllerByIdentifier("operations--products--clinics--clients--transfers--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--clinics--clients--transfers--dashboard").doTransfersDashboard()
    }
  }

  doDatesHTML() {

    var datesHtml = ``

    this.application.dates.forEach(element => {
      datesHtml += `<button type="button" class="btn btn-flat-dark btn-no-border btn-sm w-100 px-1 mx-1 f-065" data-action="${this.controllerName}#changeDate" data-id="${element.id}" data-${this.controllerName}-target="btn-${element.id}">${element.date_pretty}</button>`
    });

    var html = `<div class="btn-group" role="group" style="box-shadow:none" data-${this.controllerName}-target="datesBtnGroup">
                  ${datesHtml}
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.innerHTML = html)
    }).then(() => {
      controller.nameTarget(`btn-${controller.application.dates[0].id}`).classList.remove(`btn-flat-dark`)
      controller.nameTarget(`btn-${controller.application.dates[0].id}`).classList.add(`btn-primary`)
      // controller.rollDates()
    })
  }

  rollDates() {
    // $(this.datesBtnGroupTarget).stop().animate({ scrollRight: $(this.datesBtnGroupTarget)[0].style.width }, 1000);
    $(this.datesBtnGroupTarget).animate($(this.datesBtnGroupTarget)[0].scrollLeft -= 100, 1000);
    // $(this.datesBtnGroupTarget).stop().animate({ scrollTop: $(this.datesBtnGroupTarget)[0].scrollHeight }, 1000);
  }

  toggleDateBtn(id) {
    this.application.dates.forEach(element => {
      if (element.id == id) {
        this.nameTarget(`btn-${element.id}`).classList.remove(`btn-flat-dark`)
        this.nameTarget(`btn-${element.id}`).classList.add(`btn-primary`)
      } else {
        this.nameTarget(`btn-${element.id}`).classList.add(`btn-flat-dark`)
        this.nameTarget(`btn-${element.id}`).classList.remove(`btn-primary`)

      }
    });
  }

  doDatesPreloader() {
    var html = `<div class="row mb-3 w-100">
                  <div class="col-2 px-1 offset-2">${this.loader}</div>
                  <div class="col-2 px-1">${this.loader}</div>
                  <div class="col-2 px-1">${this.loader}</div>
                  <div class="col-2 px-1">${this.loader}</div>
                </div>`

    this.mainTarget.innerHTML = html
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

}
